import { FrameData } from '../../types';
import { LayerRenderer } from './LayerRenderer';

export class VignetteRenderer implements LayerRenderer {
  init(): void {}

  render(
    ctx: CanvasRenderingContext2D,
    _frame: FrameData,
    settings: Record<string, number>,
    width: number,
    height: number,
  ): void {
    const darkness = settings.darkness ?? 0.6;
    const radius = settings.radius ?? 0.7;
    const cx = width / 2;
    const cy = height / 2;
    const maxDim = Math.max(width, height);
    const innerRadius = maxDim * radius * 0.5;
    const outerRadius = maxDim * 0.75;

    const gradient = ctx.createRadialGradient(cx, cy, innerRadius, cx, cy, outerRadius);
    gradient.addColorStop(0, 'rgba(0, 0, 0, 0)');
    gradient.addColorStop(1, `rgba(0, 0, 0, ${darkness})`);

    ctx.fillStyle = gradient;
    ctx.fillRect(0, 0, width, height);
  }

  resize(): void {}
  destroy(): void {}
}
